import { IToken } from '../../models';
import moment from 'moment';
import queryString from 'query-string';
/**
 * Accepts amount in cents and return string to display amount
 * TODO: Require formating - What would be the format of the amount?
 */
export function getAmountToDisplayFromAmountCents(amountInCents: number | undefined): string {
    let amountToDisplay = '';
    if (!amountInCents) return amountToDisplay;

    amountToDisplay = `$${(amountInCents / 100).toFixed(2)}`;
    return amountToDisplay.trim();
}
const getPayload = (jwt: string): IToken | undefined => {
    // A JWT has 3 parts separated by '.'
    // The middle part is a base64 encoded JSON
    // decode the base64
    if (jwt) {
        const token = atob(jwt.split('.')[1]);
        return JSON.parse(token);
    } else return undefined;
};
/**
 * Check whether token is not expired
 * @param token
 */
export const CheckTokenExpiry = (token: string) => {
    const payload: IToken | undefined = getPayload(token);
    if (payload) {
        const expiry = new Date(0);
        expiry.setUTCSeconds(payload.exp);
        //console.log("expiration", expiry);
        const now = new Date();
        if (expiry < now) {
            let state = { local: true };
            window.history.pushState(state, '', '/'); // window.history.pushState(state, "", "/"); -- Logout
            window.location.reload();
            //console.log("JWT has expired or will expire soon");
        } //else {
        //console.log("JWT is valid for more than 5 minutes", payload);
        //}
    }
};
export const getDateToDisplay = (date: string | undefined, currentFormat: string, desiredFormat: string): string => {
    if (date && moment(date, currentFormat).isValid()) return moment(date, currentFormat).format(desiredFormat);
    return '';
};

export const getFacilityId = (): string => {
    const queriedString = queryString.parse(location.search);
    const { facilityId } = queriedString;
    return (facilityId as string) || '';
};
export const getWeekdays = (): string[] => {
    moment.updateLocale('en', {
        week: {
            dow: 1, // Monday
        },
    });
    const weekDays = moment.weekdays(true);
    return weekDays;
}

export const getDateFormattedForEditing = (date: Date) => {
    const formattedDate = moment(date).format('yyyy-MM-DD');
    return formattedDate;
}

export const getDateFormattedForDisplay = (date: Date) => {
    const formattedDate = moment(date).format('DD MMM yyyy');
    return formattedDate;
}

export const getDateWithoutTimePartForSaving = (date: Date) => {
    return new Date(new Date(moment(date).format('YYYY-MM-DD')).toISOString());
}